import { render, staticRenderFns } from "./log.vue?vue&type=template&id=20256d60&scoped=true&"
import script from "./log.vue?vue&type=script&lang=js&"
export * from "./log.vue?vue&type=script&lang=js&"
import style0 from "./log.vue?vue&type=style&index=0&id=20256d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20256d60",
  null
  
)

export default component.exports